import React, { FC } from 'react';
import Tooltip from 'HOC/Tooltip';
import Pill from 'Components/Pill';
import injectSheet from 'react-jss';
import styleSheet from './styles';

interface Props {
  classes?: any;
  overflow?: any[];
}

const OverflowPill: FC<Props> = (props: Props) => {
  const { classes, overflow } = props;

  const tooltipDescription = (
    <div>
      {overflow.map((pill: any, index: number) => {
        return (
          <div key={pill}>
            {pill}
            {index !== overflow.length - 1 && (
              <div className={classes.pillDividerVertical} />
            )}
          </div>
        );
      })}
    </div>
  );

  return (
    <div className={classes.pillContainerHorizontal}>
      <Tooltip
        position="right"
        offsetTop={-5}
        offsetLeft={50}
        text={tooltipDescription}
        width="280px"
        display="flex"
        backgroundColor="#FFFFFF"
        disableArrow
        overrideEvents={{
          showToolTip: ['onClick', 'onFocus'],
          hideToolTip: ['onBlur'],
        }}
        parentText="Overflow Pill"
      >
        <Pill
          text={`${overflow.length}+`}
          border="1.5px solid #085FE54D"
          backgroundColor="#FFFFFF"
          focusOnClick
        />
      </Tooltip>
    </div>
  );
};

OverflowPill.defaultProps = {
  classes: {},
  overflow: [],
};

export default injectSheet(styleSheet)(OverflowPill);
